import { ShieldCheck, Umbrella } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

import { Button } from '../ui/Button';
import { paths } from '../../routes/paths';
import pt from '../../locales/pt';

/** .pen `ds/empty-state` (instância "sem selfie"). */
function NoSelfieState() {
  const copy = pt.emergencyFund.dashboard.empty;

  return (
    <div className="flex flex-col items-center gap-space-4 rounded-ds-lg border border-border bg-card p-space-8 text-center shadow-sm dark:shadow-none">
      <div className="relative flex h-24 w-24 items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-sage-glow-soft blur-[10px]" aria-hidden />
        <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-sage-tint text-sage-on-tint">
          <Umbrella className="h-[26px] w-[26px]" aria-hidden />
        </span>
      </div>
      <h2 className="type-title-card text-foreground">{copy.comingSoonTitle}</h2>
      <p className="type-body-sm max-w-[380px] text-muted-foreground">{copy.comingSoonBody}</p>
    </div>
  );
}

/** .pen `Fundo de Emergência · Vazio`. */
function IntroState() {
  const copy = pt.emergencyFund.dashboard.empty;

  return (
    <div className="flex flex-col gap-space-5">
      <div className="relative flex h-[190px] items-end overflow-hidden rounded-ds-xl bg-gradient-to-br from-sage-gradient-hero-from to-sage-gradient-hero-to p-space-4 shadow-[0_10px_24px] shadow-sage-glow-soft">
        <span className="absolute -right-5 -top-8 h-[150px] w-[150px] rounded-full bg-sage-50/10" aria-hidden />
        <span className="absolute -bottom-8 left-5 h-[120px] w-[120px] rounded-full bg-sage-50/[0.08]" aria-hidden />
        <Umbrella className="absolute left-5 top-5 h-[30px] w-[30px] text-sage-50" aria-hidden />
        <h2 className="type-title-page relative text-sage-50">{copy.heroTitle}</h2>
      </div>

      <p
        className="type-body-sm leading-relaxed text-muted-foreground [&_b]:font-semibold [&_b]:text-foreground"
        dangerouslySetInnerHTML={{ __html: copy.body }}
      />

      <ol className="flex flex-col gap-space-2-5">
        {copy.steps.map((step, index) => (
          <li key={step} className="flex items-center gap-space-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-sage-border bg-sage-tint text-[11px] font-bold text-sage-on-tint">
              {index + 1}
            </span>
            <span className="type-body-sm text-muted-foreground">{step}</span>
          </li>
        ))}
      </ol>

      <Button asChild className="w-full">
        <Link to={paths.emergencyFundWizard}>
          <ShieldCheck className="mr-2 h-4 w-4" aria-hidden />
          {copy.cta}
        </Link>
      </Button>
    </div>
  );
}

export function EmergencyFundEmptyState({ hasSelfie }) {
  return hasSelfie ? <IntroState /> : <NoSelfieState />;
}

export default EmergencyFundEmptyState;
